import { MenuItem, MenuItemElement, MenuItemProps, Slot } from '@farol-ds/react'
import { cloneElement, forwardRef, Fragment, isValidElement, ReactNode } from 'react'

export type ContextMenuItemElement = MenuItemElement

export type ContextMenuItemProps = Omit<MenuItemProps, 'type' | 'current' | 'block'> & {
  leftIcon?: ReactNode
  order?: number
}

export const ContextMenuItem = forwardRef<ContextMenuItemElement, ContextMenuItemProps>(
  function ContextMenuItem(props, forwardedRef) {
    const { children, disabled, leftIcon, asChild, order, ...rest } = props
    const Component = asChild ? Slot : Fragment

    return (
      <MenuItem {...rest} block disabled={disabled} ref={forwardedRef} asChild={asChild}>
        <Component>{renderChildren(props)}</Component>
      </MenuItem>
    )
  }
)

function renderChildren(props: ContextMenuItemProps): ReactNode {
  const { asChild, children } = props
  if (asChild && isValidElement<{ children: ReactNode }>(children)) {
    return cloneElement(children, {}, renderChild(children.props.children, props))
  }
  return renderChild(children, props)
}

function renderChild(children: ReactNode, props: ContextMenuItemProps) {
  const { leftIcon } = props
  return (
    <MenuItem.Content>
      {leftIcon && <MenuItem.Leading>{leftIcon}</MenuItem.Leading>}
      {children}
    </MenuItem.Content>
  )
}
